export const modes = {
    create_send: 1,
    find_send: 2,
};
